<div class="add-container">
    <h1 class="add-title pb-0">{{ config.title }}</h1>

    <form class="add-card__form" [formGroup]="form" (submit)="submit()">
        <h4 style="padding-bottom: 20px;">{{ config.text }}</h4>

        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Motiv</mat-label>
                    <mat-select formControlName="motiv" [compareWith]="compareById">
                        <mat-option *ngFor="let m of motive" [value]="m" [disabled]="m.id === -1">
                            {{ m.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="form.get('motiv')?.hasError('placeholderSelected') || form.get('motiv')?.hasError('required')">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row" *ngIf="isAlteleSelected">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Specificați motivul</mat-label>
                    <input type="text" matInput formControlName="motivAltele" />
                    <mat-error *ngIf="!form.controls['motivAltele'].valid && form.controls['motivAltele'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col d-flex justify-content-between">
                <button type="button" class="buttons" mat-flat-button (click)="close()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" mat-flat-button color="primary" type="submit"
                    [disabled]="form.invalid || isSubmitting">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>

    <div class="section-spinner position-absolute" *ngIf="isLoading || isSubmitting">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>